import React, { Component } from 'react';

import { FormattedMessage, injectIntl, InjectedIntl } from 'react-intl';

/* eslint frontbucket-patterns/no-old-modal-dialog: "warn" */
import Modal, { ModalTransition } from '@atlaskit/modal-dialog';

import { commonMessages } from 'src/i18n';

import messages from './download-repository-lfs-modal-dialog.i18n';

type DownloadRepositoryLfsModalProps = {
  onDownload: () => void;
  onClose: () => void;
  isOpen: boolean;
  intl: InjectedIntl;
};

class DownloadRepositoryLfsModalDialog extends Component<DownloadRepositoryLfsModalProps> {
  render() {
    const { intl, onClose, onDownload } = this.props;
    const link = (
      <a href="https://confluence.atlassian.com/x/RjRmMQ" target="_blank">
        {intl.formatMessage(messages.lfsLimitationsLink)}
      </a>
    );

    return (
      <ModalTransition>
        {this.props.isOpen && (
          <Modal
            actions={[
              {
                text: intl.formatMessage(messages.actionDownloadRepository),
                onClick: onDownload,
              },
              {
                text: intl.formatMessage(commonMessages.cancel),
                onClick: onClose,
              },
            ]}
            onClose={onClose}
            heading={intl.formatMessage(messages.heading)}
            width="small"
          >
            <FormattedMessage tagName="p" {...messages.downloadWarning} />
            <FormattedMessage
              tagName="p"
              {...messages.readMore}
              values={{ link }}
            />
          </Modal>
        )}
      </ModalTransition>
    );
  }
}

export default injectIntl(DownloadRepositoryLfsModalDialog);
